import { render } from "./Auction.vue?vue&type=template&id=55d98850"
import script from "./Auction.vue?vue&type=script&lang=js"
export * from "./Auction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"assets/vue_apps/auctions_vue/views/Auction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55d98850"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55d98850', __exports__)) {
    api.reload('55d98850', __exports__)
  }
  
  module.hot.accept("./Auction.vue?vue&type=template&id=55d98850", () => {
    api.rerender('55d98850', render)
  })

}


export default __exports__